import React from "react";

const Bash_Man = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Man</h2>
      <p>Show the manual page for commands.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>man command</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>man ls
man bash</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use q to quit the man pager.</p>
    </div>
  );
};

export default Bash_Man;
